module.exports = __webpack_public_path__ + "static/media/logosmalltrans.605a4d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logosmalltrans.png
// module id = 389
// module chunks = 0